import AboutMePicture from "../Components/AboutMePicture";

export default function About() {
  return (
    <main className="aboutPage">
      <div id="aboutMeText">
        <h1>About me</h1>
        <div className="aboutMeAligner">
          <AboutMePicture />
          <div className="aboutMeDetails">
            <div className="aboutMeInfoPlanes">
              <div className="aboutMePlane">
                <h2>Experience</h2>
                <p>5 years+</p>
              </div>
            </div>
            <div id="aboutMeDescription">
              <h2>Hi, I’m Milan Rahmie</h2>
              <p>
                A software development student at SintLucas in the Netherlands. 
                My love for game development started when I was 14, and since then,
                I’ve been focused on mastering the art of coding. I’m dedicated to
                improving my skills and constantly pushing myself to create better,
                more innovative projects. Hardworking and motivated, I run on
                challenges and love collaborating with others to bring ideas to life.
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
